module.exports = __webpack_public_path__ + "static/media/7.65b7e96c.png";